var React = require('react');

function MudraAbhaya (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M21,16c0,0,0-9.896,0-11s0.896-2,2-2s2,0.896,2,2\n\ts0,16.688,0,16.688c0,1.625,1.416,1.533,1.781,0.6c0.366-0.934,1.953-4.986,2.355-6.016c0.403-1.029,1.563-1.535,2.592-1.133\n\tc1.029,0.402,1.536,1.563,1.133,2.592c-0.402,1.027-3.098,7.914-3.463,8.846C27.515,31.387,26.292,35,21.875,35\n\tC21.273,35,18,35,18,35 M13,18c0,0,0-9.896,0-11s-0.896-2-2-2S9,5.896,9,7s0,19,0,21c0,4.917,2.625,7,6,7c0.342,0,1,0,1,0 M21,16\n\tc0,0,0-11.896,0-13s-0.896-2-2-2s-2,0.896-2,2s0,13,0,13 M17,16c0-1.104,0-9.896,0-11s-0.896-2-2-2s-2,0.896-2,2s0,9.896,0,11"}));
}

MudraAbhaya.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = MudraAbhaya;

MudraAbhaya.default = MudraAbhaya;
